import React from "react";
import DashboardLayout from "layouts/Dashboard";
import { AppBar, Box, Tab, Tabs } from "@material-ui/core";
import ContentDisponibilidadUmbralPlus from "./components/ContentDisponibilidadUmbralPlus";
import UserNotification from "../Dashboard/components/UserNotification";
import CustomTabPanel from "../../components/CustomTabPanel";
import queryString from "query-string";
import ThresholdAvailability from "../DisponibilidadUmbral";
import { useTranslation } from 'react-i18next';

const ThresholdAvailabilityPlus = () => {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = React.useState(0);

    function handleChangeTab(event, newValue) {
        const queryParamsParsed = queryString.parse(document.location.search);
        queryParamsParsed["tab"] = newValue;
        window.history.replaceState(
            null,
            (t && typeof t === 'function') ? (t('dashboard-layout.title.general-status') || 'Estado General') : 'Estado General',
            `/disponibilidadumbral?${queryString.stringify(queryParamsParsed)}`
        );
        setActiveTab(newValue);
    }

    React.useLayoutEffect(() => {
        const parsed = queryString.parse(document.location.search);
        const tab = parsed?.tab ?? 0;
        setActiveTab(Number(tab));
    }, []);

    return (
        <Box>
            <UserNotification />
            <DashboardLayout
                title={(t && typeof t === 'function') ? (t('manageObjectives.tabs.flashboard') || 'Flashboard Visibilidad') : 'Flashboard Visibilidad'}
                callbackFromParent={() => {}}
                isFirstTime={true}
            >
                <Box style={{ backgroundColor: "white" }}>
                    <AppBar
                        position="static"
                        style={{
                            backgroundColor: "#333333",
                        }}
                    >
                        <Tabs value={activeTab} onChange={handleChangeTab}>
                            <Tab label={(t && typeof t === 'function') ? (t('flashboard.tab.flashboard') || 'Flashboard') : 'Flashboard'} />
                            <Tab label={(t && typeof t === 'function') ? (t('flashboard.tab.flashboard-plus') || 'Flashboard Plus') : 'Flashboard Plus'} />
                        </Tabs>
                    </AppBar>
                    <CustomTabPanel value={activeTab} index={0}>
                        <ThresholdAvailability />
                    </CustomTabPanel>
                    <CustomTabPanel value={activeTab} index={1}>
                        <ContentDisponibilidadUmbralPlus />
                    </CustomTabPanel>
                </Box>
            </DashboardLayout>
        </Box>
    );
};

export default ThresholdAvailabilityPlus;
